import React from 'react';
import { Fish, Waves, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const FishingSection = ({ t }) => {
  if (!t.fishing) return null;

  const location1 = t.fishing.locations && t.fishing.locations[0];
  const location2 = t.fishing.locations && t.fishing.locations[1];

  return (
    <section id="fishing" className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <Fish className="h-12 w-12 text-orange-500" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.fishing.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold mb-4">
            {t.fishing.subtitle}
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            {t.fishing.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {location1 && (
            <Card className="bg-stone-800 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
              <CardHeader>
                <div className="flex items-center mb-4">
                  <Waves className="h-8 w-8 text-orange-500 mr-3" />
                  <CardTitle className="text-2xl text-orange-500">
                    {location1.name}
                  </CardTitle>
                </div>
                <CardDescription className="text-gray-300 text-base">
                  {location1.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {location1.species && location1.species[0] && (
                    <span className="px-4 py-2 bg-orange-500/10 border border-orange-500/30 text-orange-500 rounded-full text-sm font-medium">
                      {location1.species[0]}
                    </span>
                  )}
                  {location1.species && location1.species[1] && (
                    <span className="px-4 py-2 bg-orange-500/10 border border-orange-500/30 text-orange-500 rounded-full text-sm font-medium">
                      {location1.species[1]}
                    </span>
                  )}
                  {location1.species && location1.species[2] && (
                    <span className="px-4 py-2 bg-orange-500/10 border border-orange-500/30 text-orange-500 rounded-full text-sm font-medium">
                      {location1.species[2]}
                    </span>
                  )}
                </div>
              </CardContent>
            </Card>
          )}

          {location2 && (
            <Card className="bg-stone-800 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
              <CardHeader>
                <div className="flex items-center mb-4">
                  <Waves className="h-8 w-8 text-orange-500 mr-3" />
                  <CardTitle className="text-2xl text-orange-500">
                    {location2.name}
                  </CardTitle>
                </div>
                <CardDescription className="text-gray-300 text-base">
                  {location2.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {location2.species && location2.species[0] && (
                    <span className="px-4 py-2 bg-orange-500/10 border border-orange-500/30 text-orange-500 rounded-full text-sm font-medium">
                      {location2.species[0]}
                    </span>
                  )}
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Important Note */}
        <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-6 flex items-start">
          <AlertCircle className="h-6 w-6 text-orange-500 mr-4 flex-shrink-0 mt-1" />
          <p className="text-gray-300 text-lg">
            <strong className="text-orange-500">Note importante:</strong> {t.fishing.note}
          </p>
        </div>
      </div>
    </section>
  );
};
